import React from 'react';
import PropTypes from 'prop-types';
import './ResetPassword.css';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import { withStyles } from '@material-ui/core/styles';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        outline: 'none',
    },
});

class ChangeEmailConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            successChangeRequest: false,
            token: this.props.match.params.token,
            tokenIsValid: true
        };
    }

    componentWillMount() {
        fetch("/account-management/api/check-token/" + this.state.token)
            .then(
                (response) => {
                    if(response.status === 200) {
                        fetch("/account-management/api/change-email/" + this.state.token, {
                            method: 'put',
                            body: JSON.stringify({password: this.state.password1}),
                            headers: {'Content-Type': 'application/json'}
                        })
                            .then(
                                (response) => {
                                    if(200 === response.status) {
                                        this.setState({successChangeRequest: true});
                                        setInterval(this.redirect, 3000);
                                    } else {
                                        console.error(`Failed to change password: ${response.status}, ${response}`);
                                    }
                                },
                                (error) => {
                                    console.error(`Failed to change password.`, error);
                                }
                            )

                    } else {
                        this.setState({ tokenIsValid: false });
                    }
                },
                (error) => {
                    console.error(`Failed to check token: ${this.state.token}`, error);
                }
            )

    }

    componentDidMount() {

    }

    render() {
        const { classes } = this.props;

        return <form autoComplete="off" className={'reset-password-form'}>
            <h3 className={'reset-password-label'}>Change email...</h3>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.state.successChangeRequest}
                >
                <div style={getModalStyle()} className={classes.paper}>
                    <Typography variant="subtitle1" id="simple-modal-description">
                        The email address has been successfully changed.
                    </Typography>
                </div>
            </Modal>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={!this.state.tokenIsValid}
            >
                <div style={getModalStyle()} className={classes.paper}>
                    <Typography variant="subtitle1" id="simple-modal-description">
                        The provided token is not valid.
                    </Typography>
                </div>
            </Modal>

        </form>;
    }
}

ChangeEmailConfirmation.propTypes = {
    classes: PropTypes.object.isRequired,
};

const ChangeEmailConfirmationWrapped = withStyles(styles)(ChangeEmailConfirmation);

export default ChangeEmailConfirmationWrapped;
